import { render, staticRenderFns } from "./subpageHeader.vue?vue&type=template&id=2033e7d2&scoped=true"
import script from "./subpageHeader.vue?vue&type=script&lang=js"
export * from "./subpageHeader.vue?vue&type=script&lang=js"
import style0 from "./subpageHeader.vue?vue&type=style&index=0&id=2033e7d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2033e7d2",
  null
  
)

export default component.exports